import { render, staticRenderFns } from "./ServicesData.vue?vue&type=template&id=ae5cd5de&scoped=true"
import script from "./ServicesData.vue?vue&type=script&lang=js"
export * from "./ServicesData.vue?vue&type=script&lang=js"
import style0 from "./ServicesData.vue?vue&type=style&index=0&id=ae5cd5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5cd5de",
  null
  
)

export default component.exports